import React from "react";
import { CartExpandedDetails } from "./ExpandedDetails";
import moment from "moment-timezone";

const OrderHistoryOfActiveSession = ({ themeData, language, ConsumerId }) => {
    return (
        <div className="card card-custom">
            <CartExpandedDetails
                data={ConsumerId}
                language={language}
                themeData={{ timeZone: moment.tz.guess() }}
                type="order-history"
            />
        </div>
    );
};

export default OrderHistoryOfActiveSession;
